import { Iuser } from "@api/types";
import { profileContext } from "@views/user/User";
import { useContext } from "react";

export default function useProfile(): Iuser {
  const { user } = useContext(profileContext);
  return user;
}
